import planner from "./planner";

export const pods = {
    planner: planner
};
